import {emotionStyled} from '@packages/utilities/styled';
import {Autocomplete} from '@packages/systems/spring';

/**
 * `emotionStyled` types are having trouble composing the inferred generic types from `Autocomplete` when returning the curried styled component.
 * So, we will just manually set it for now.
 */
// @ts-expect-error - TS2322 - Type 'typeof Autocomplete' is not assignable to type 'typeof Autocomplete'.
export const BrandedAutocomplete: typeof Autocomplete = emotionStyled(
  Autocomplete
)({
  '[data-sc*="AutocompleteInput"]': {
    minHeight: '$10',
  },
  '[data-sc*="Tag"]': {
    height: '$7',
    paddingX: '$2',
  },
  '[data-sc*="Tag"] + button': {
    height: '$7',
    width: '$7',
  },
});

// @ts-expect-error - TS2339 - Property 'displayName' does not exist on type
BrandedAutocomplete.displayName = 'BrandedAutocomplete';
